import { render } from "./ImageContainer.vue?vue&type=template&id=2d6dba2e"
import script from "./ImageContainer.vue?vue&type=script&lang=js"
export * from "./ImageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__